import { render, staticRenderFns } from "./TaxGroupForm.vue?vue&type=template&id=58d53464&"
import script from "./TaxGroupForm.vue?vue&type=script&lang=js&"
export * from "./TaxGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./TaxGroupForm.vue?vue&type=style&index=0&id=58d53464&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports